import { assign } from 'xstate';
import { FraudAlloyContext } from './fraudAlloyMachine';
import { InitializingFraudAlloyResult } from './types/actors';
import { FraudAlloyMachineEvents } from './types/events';

/**
 * Assigns fraudAlloyRes to context for event `SEND_INITIALIZE_FRAUD_ALLOY`
 */
export const assignFraudAlloyInitResponse = assign<
  FraudAlloyContext,
  FraudAlloyMachineEvents,
  InitializingFraudAlloyResult,
  FraudAlloyMachineEvents,
  never
>({
  neuroIdSiteId: (_, params) => {
    return params.fraudAlloyRes?.neuroIdSiteId || null;
  },
  neuroUserId: (_, params) => {
    return params.fraudAlloyRes?.neuroUserId || null;
  },
  iovationBlackboxId: (_, params) => {
    return params.fraudAlloyRes?.iovationBlackboxId || null;
  },
});
